import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

const HomePage = lazy(() => import("./home_page"));
const AboutPage = lazy(() => import("./about_us_page"));
const ServicesPage = lazy(() => import("./services_page"));
const ContactUs = lazy(() => import("./contact_us_page"));
const ForgotPassword = lazy(() => import("./components/ForgotPassword"));
const PrivacyPolicyPage = lazy(() => import("./privacy_policy_page"));
const TermsPage = lazy(() => import("./terms_page"));
const CareersPage = lazy(() => import("./careers_page"));
const JobDetailPage = lazy(() => import("./job_detail_page"));
const JobApplyPage = lazy(() => import("./job_apply_page"));
const NotFoundPage = lazy(() => import("./not_found_page"));

// ScrollToTop component ensures page resets scroll on route change
function ScrollToTop() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense
        fallback={
          <div className="min-h-screen bg-gradient-to-b from-[#0a1833] to-black flex flex-col items-center justify-center gap-4">
            <div className="relative">
              <div className="w-12 h-12 rounded-full absolute border-4 border-solid border-gray-200"></div>
              <div className="w-12 h-12 rounded-full animate-spin absolute border-4 border-solid border-[#FF541F] border-t-transparent"></div>
            </div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/careers/:slug" element={<JobDetailPage />} />
          <Route path="/careers/:slug/apply" element={<JobApplyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;

